define(['jquery', 'forms'], function ($, Forms) {
	var InsuranceCertificate = function() {
		var self = this;

		self.forms = new Forms();
		self.$ervBody = $('#erv-body');
		self.$form = $('#insurance-certificate');
		self.$formInputContainer = $('#insurance-certificate-input-container');
		self.$policyNumberInput = $('#certificate-policy-number-search-input');

        self.deleteIncluded = function ($person) {
			var deletedIndex = $person.data('id');
			$person.remove();
			self.refreshIncluded(deletedIndex);
			return deletedIndex;
		};
		
		self.refreshIncluded = function (deletedIndex) {
			var $allAdded = self.$includedList.find('.person.added');

			var $allNext = $allAdded.filter(function () {
				return ($(this).data('id') > deletedIndex); 
			});

			$allNext.each(function () {
				var $person = $(this);
				var index = $person.data('id'),
					newIndex = (index - 1);

				$person.find('.index').text(newIndex + 1);
				$person.data('id', newIndex);

				$person.find('input[type=text], input[data-inputtype=text]').each(function () {
					var $input = $(this);
					$input.attr('name', $input.attr('name').replace(index, newIndex));
					$input.attr('id', $input.attr('id').replace(index, newIndex));
				});

				$person.find('label').each(function () {
					var $label = $(this);
					$label.attr('for', $label.attr('for').replace(index, newIndex));
				});
			});
		};
		
		self.addIncluded = function () {
			var currentIndex = self.$includedList.find('.person').length,
				html = self.$includePersonTemplate.html().replace(/{{index}}/g, currentIndex);

			var $html = $(html);
			$html.find('.index').text(currentIndex + 1);

			$html.insertAfter($(self.$includedList.find('.person').last()));

			var $inputs = $html.find('input');

			$inputs.each(function () {

				$(this).rules('add',
				{
					required: true,
					messages: {
						required: $(this).data('val-required')
					}
				});

				if ($(this).attr('id').indexOf('Birthday') > 0) {
					$(this).rules('add',
					{
						regex: $(this).data('val-regex-pattern'),
						messages: {
							regex: $(this).data('val-regex')
						}
					});
				}

				$(this).on('blur', function () {
					$(this).valid();
				});
			});
		};

		self.setupEventHandlingAfterSearch = function () {
            self.$policyNumberInput.change(function() {
                self.$formInputContainer.html('');
            });
			self.$includePersonTemplate = self.$form.find("#include-person-template");
			self.$includedList = self.$form.find('#included-people');

			self.$form.find('#add-included').on('click', function (e) {
				e.preventDefault();
				self.addIncluded();
			});

			self.$includedList.on('click', '.person.added .remove-included', function (e) {
				e.preventDefault();
				self.deleteIncluded($(this).parents('.person.added'));
			});

			self.$form.find('#output-list input').on('change', function () {
				var $radio = $(this),
					$additionalAddress = self.$form.find('#insurance-certificate-mail-section');

				var $inputs = $additionalAddress.find('input[data-val="true"]');


				if ($radio.attr('id') === "Input_InsuranceCertificateType_Mail") {
					$additionalAddress.removeClass('hide');

					$inputs.each(function () {
						if ($(this).data('val-requiredif') != 'undefined') {
							$(this).rules('add',
							{
								requiredif: {
									dependentproperty: $(this).data('val-requiredif-dependentproperty'),
									targetvalue: $(this).data('val-requiredif-targetvalue')
								},
								messages: {
									requiredif: ''
								}
							});
						}
					});

				} else {
					$additionalAddress.addClass('hide');
					$inputs.each(function () {
						$(this).rules('remove', 'requiredif');
					})
				}

				$inputs.removeClass('valid');
				$inputs.removeClass('input-validation-error');
				$inputs.removeClass('input-validation-valid');
			});

			self.$form.find('#Input_CompanyName').keyup(function () {
				self.$form.find('#Input_OtherRecipient').val($(this).val());
			});

			self.forms.initPickers();

			self.$form.find('#insurance-certificate-order').on('click', function (e) {
				if (!$(this).parents('form').valid()) {
					e.preventDefault();
					e.stopPropagation();
					return;
				}
				
				self.forms.activateLoading($(this).parents('form'), false);
			});
		}

		self.setupEventHandling = function () {
            self.$form.find('#trigger-get-insurance-certificate').on('click', function (e) {
				e.preventDefault();
				e.stopPropagation();

				self.$form.find('.validation-summary-errors').remove();

				self.$formInputContainer.html('');

				if (!self.$form.valid()) {
					return false;
				}

				self.forms.activateLoading(self.$form, false);

				var certificateType = self.$form.find('#Input_CertificateType :selected').val();
				$.ajax({
					url: self.$form.data('form-url') + '?policyNumber=' + self.$form.find('input[name="Input.PolicyNumber"]').val() + '&certificateType=' + certificateType
				}).success(function (html) {
					if (html && (certificateType == 'NisCertificateSE' || certificateType == 'VisitorCertificate')) {
						var newWin = window.open('', 'Print-Window');
						newWin.document.open();
						newWin.document.write('<html><body onload="window.print()">' + html + '</body></html>');
						newWin.document.close();
						setTimeout(function () { newWin.close(); }, 10);
						return;
					}

					self.$formInputContainer.html(html);
					setTimeout(function () {
							var $inputs = self.$formInputContainer.find('#required-fields input[type="text"][data-val="true"], #required-fields input[data-inputtype="text"][data-val="true"]');

							$inputs.each(function () {
								var $input = $(this);

								if ($input.data('val-required') != 'undefined') {
									$input.rules('add',
									{
										required: true,
										messages: {
											required: $input.data('val-required')
										}
									});
								}

								if ($input.attr('id').indexOf('Birthday') > 0 || $input.attr('id').indexOf('Email') > 0) {
									$input.rules('add',
									{
										regex: $input.data('val-regex-pattern'),
										messages: {
											regex: $input.data('val-regex')
										}
									});
								}

								$input.on('blur', function () {
									$(this).valid();
								});
							});

							self.$formInputContainer.find('.is-date input').each(function () {
								$(this).rules('remove', 'date');
							});

						self.setupEventHandlingAfterSearch();
					}, 200);
				})
				.always(function () {
					self.forms.deactivateLoading(self.$form);
				});

				return false;
			});

			self.$form.on('keydown', function (e) {
				if ($(e.target).is('#Input_PolicyNumber') && e.keyCode === 13) {
					e.preventDefault(); //stop event
					$(e.target).parent().find('.btn').click();
				}
				return true;
			});

			self.setupEventHandlingAfterSearch();
		};
	};

	InsuranceCertificate.prototype.init = function () {
		var self = this;

		self.setupEventHandling();
	}

	return InsuranceCertificate;
});